import translations from './ListingDetailsDrawer.translations'
import Alerts from './components/Tabs/Alerts/Alerts.vue'
import Comments from './components/Tabs/Comments/Comments.vue'
import PricingInsights from './components/Tabs/PricingInsights/PricingInsights.vue'
import ProductSpecifications from './components/Tabs/ProductSpecifications/ProductSpecifications.vue'
import Shipping from './components/Tabs/Shipping/Shipping.vue'
import SimilarListings from './components/Tabs/SimilarListings/SimilarListings.vue'

export const QUERY_MODAL_NAME = 'm-listing-id'
export const QUERY_MODAL_TAB_NAME = 'm-listing-tab'

export const TAB_NAMES = {
  ALERTS: 'alerts',
  COMMENTS: 'comments',
  SHIPPING: 'shipping',
  PRODUCT_SPECIFICATIONS: 'product-specifications',
  SIMILAR_LISTINGS: 'similar-listings',
  BACKBOX_INSIGHTS: 'pricing-insights',
} as const

export type TabName = (typeof TAB_NAMES)[keyof typeof TAB_NAMES]

export const TABS_INFO = [
  {
    component: Alerts,
    tabName: TAB_NAMES.ALERTS,
    translationKey: translations.alertsTabLabel,
  },
  {
    component: Comments,
    tabName: TAB_NAMES.COMMENTS,
    translationKey: translations.commentsTabLabel,
  },
  {
    component: Shipping,
    tabName: TAB_NAMES.SHIPPING,
    translationKey: translations.shippingTabLabel,
  },
  {
    component: ProductSpecifications,
    tabName: TAB_NAMES.PRODUCT_SPECIFICATIONS,
    translationKey: translations.productSpecificationsTabLabel,
  },
  {
    component: SimilarListings,
    tabName: TAB_NAMES.SIMILAR_LISTINGS,
    translationKey: translations.similarListingsTabLabel,
  },
  {
    component: PricingInsights,
    tabName: TAB_NAMES.BACKBOX_INSIGHTS,
    translationKey: translations.pricingInsightsTabLabel,
  },
]

export const MODAL_NAME = 'listings.detail'
